<template>
  <!-- 添加编辑  专题 -->
  <el-form
    v-loading="loading"
    ref="ruleFormRef"
    :model="ruleForm"
    :rules="rules"
    label-width="110px"
    class="demo-ruleForm"
    size="large"
    status-icon
  >
    <el-form-item label="专题名称" prop="name">
      <el-input
        class="middle_input"
        clearable
        v-model="ruleForm.name"
        placeholder="请填写专题名称"
      />
    </el-form-item>
    <!-- <el-form-item label="所属上级分类" prop="category">
      <el-select
        v-model="ruleForm.category"
        class="m-2 middle_input"
        placeholder="请选择所属上级分类"
        size="large"
      >
        <el-option
          v-for="item in firstLevelList"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
      </el-select>
    </el-form-item> -->
    <!-- <el-form-item label="Tdk关键字" prop="keyword">
      <el-col :span="24">
        <el-tag
          v-for="(item, index) in ruleForm.keyword"
          :key="item"
          closable
          @close="delTag(index, ruleForm.keyword)"
        >
          {{ item }}
        </el-tag>
      </el-col>
      <el-col v-if="ruleForm.keyword.length !== 6">
        <el-tooltip
          effect="dark"
          content="单个关键字2-8个字，关键字数目不能超过6个,便于搜索引擎收录页面"
          placement="top-start"
        >
          <el-input
            class="small_input"
            v-model="keyword"
            placeholder="请输入Tdk关键字"
            maxlength="8"
            clearable
          ></el-input>
        </el-tooltip>
        <el-button
          v-if="ruleForm.keyword.length !== 6"
          type="primary"
          @click="addTag(keyword, ruleForm.keyword)"
          plain
        >
          <el-icon> <Plus /> </el-icon>&nbsp;添加
        </el-button>
      </el-col>
    </el-form-item> -->
    <!-- <el-form-item label="Tdk描述" prop="remarks">
      <el-tooltip
        class="box-item"
        effect="dark"
        content="描述主要用于该分类相应的前台文章列表页的页面描述,便于搜索引擎收录页面"
        placement="top-start"
      >
        <el-input
          v-model="ruleForm.remarks"
          :rows="4"
          show-word-limit
          type="textarea"
          placeholder="请输入Tdk描述，5到100字"
          minlength="5"
          maxlength="100"
        />
      </el-tooltip>
    </el-form-item> -->
  </el-form>
  <div slot="footer" class="from_btn">
    <el-button @click="resetForm" size="large">取消</el-button>
    <el-button v-if="!submitDisabled" type="primary" size="large" @click="submitForm(ruleFormRef)"
      :disabled = "submitDisabled">提交保存</el-button
    >
    <el-button type="primary" size="large" loading v-else>提交中</el-button>
  </div>
</template>

<script>
import { getFirstLevel } from "network/articleClassification.js";
import {
  getSpecialTopicDetail,
  addSpecialTopic,
  modifySpecialTopic,
} from "network/projectManagement.js";
import { toRefs, reactive, ref, unref, onMounted } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";

export default {
  name: "AddEditProject",
  components: {},
  emits: {
    "close-dialog": null,
    "update-list": null,
  },
  props: { editId: Number },
  setup(props, { emit }) {
    const ruleFormRef = ref();
    const data = reactive({
      loading: false,
      ruleForm: {
        name: "",
        // category: null,
        // keyword: [],
        remarks: "",
      },
      rules: {
        name: [
          { required: true, message: "请填写专题名称" },
          { min: 2, max: 50, message: "专题名称为2-50字" },
        ],
        // category: [
        //   {
        //     required: true,
        //     message: "请选择所属上级分类",
        //   },
        // ],
        // keyword: [
        //   {
        //     required: true,
        //     message: "请设置Tdk关键字",
        //     trigger: "change",
        //   },
        // ],
        // remarks: [
        //   {
        //     required: true,
        //     message: "请填写Tdk描述",
        //   },
        //   { min: 5, max: 100, message: "Tdk描述为5-100字" },
        // ],
      },
      keyword: "", //关键字
      firstLevelList: [], //上级分类
      submitDisabled:false
    });

    onMounted(() => {
      getLevelClass(); //获取全部一级分类
      //编辑-获取详情
      if (props.editId > 0) {
        data.loading = true;
        getSpecialTopicDetail(props.editId).then((result) => {
          if (result && result.code == 1) {
            data.loading = false;
            data.ruleForm = result.result;
            data.ruleForm.remarks = ""
          } else {
            data.loading = false;
            ElMessage.error(result.message);
          }
        });
      }
    });
    function getLevelClass() {
      getFirstLevel().then((res) => {
        if (res.code == 1) {
          data.firstLevelList = res.result;
        } else {
          ElMessage.error(res.message);
        }
      });
    }

    //添加关键字
    // const addTag = (val, valAll) => {
    //   if (val == "" || val == null || val.length < 2) {
    //     ElMessage.error("请输入2-8个字");
    //     return false;
    //   }
    //   if (valAll.length >= 6) {
    //     data.keyword = "";
    //     ElMessage.error("最多只能设置6个");
    //     return false;
    //   }
    //   var index = valAll.indexOf(val);
    //   if (index >= 0) {
    //     ElMessage.error("关键字[" + val + "]已存在");
    //     return false;
    //   }
    //   valAll.push(val);
    //   data.ruleForm.keyword = valAll;
    //   ElMessage({ message: "添加成功！", type: "success" });
    //   data.keyword = "";
    // };
    // //删除关键字
    // const delTag = (index, valAll) => {
    //   valAll.splice(index, 1);
    //   ElMessage({ message: "删除成功！", type: "success" });
    // };

    // 提交
    const submitForm = async () => {
      const form = unref(ruleFormRef);
      if (!form) return;
      try {
        const valid = await form.validate();
        if (!valid) {
          return false;
        } else {
          data.submitDisabled=true;
          updataAdd().then(() => {
            data.submitDisabled = false;
          });
        }
      } catch (error) {
        ElMessage.error("有必填内容未填写！");
        console.log(error);
      }
    };
    async function updataAdd() {
      data.loading = true;
      let result = "";
      if (props.editId > 0) {
        data.ruleForm.id = props.editId;
        result = await modifySpecialTopic(data.ruleForm);
      } else {
        result = await addSpecialTopic(data.ruleForm);
      }
      if (result && result.code == 1) {
        data.loading = false;
        ElMessageBox.alert(result.message, props.editId > 0 ? "编辑" : "添加", {
          confirmButtonText: "确定",
                  });
            emit("close-dialog");
            emit("update-list");
      } else {
        data.loading = false;
        ElMessageBox.alert(result.message, props.editId > 0 ? "编辑" : "添加", {
          confirmButtonText: "确定",
                });
      }
    }

    // 取消操作  关闭弹窗
    const resetForm = () => {
      emit("close-dialog");
      ruleFormRef.value.resetFields();
    };
    return {
      ...toRefs(data),
      // addTag,
      // delTag,
      submitForm,
      ruleFormRef,
      resetForm,
    };
  },
};
</script>
<style scoped>
:deep(.el-input__inner) {
  outline: none;
  line-height: 1px;
}
</style>

